import type { Static } from "runtypes";
import { Array, Boolean, Number, String, Union, Dictionary } from "runtypes";
import { QuestionsValue } from "./QuestionsValue";

export const Value = Union(String, Boolean, Number, Array(String), QuestionsValue, Dictionary(String));

export type Value = Static<typeof Value>;
